import { observer } from "mobx-react";
import { h } from "preact";
import { useRef } from "preact/hooks";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { translate, t } from "../I18n";
import { randomUUID } from "restaumatic-client";
import CrossSellingItem from "./CrossSellingItem";
const PER_PAGE = 2;
// NOTICE: Extract the Slider component if it will be used in more places
function CrossSellingList(props) {
    var _a;
    const { items } = props;
    const uuid = useRef(randomUUID());
    const isMultiPage = items.length > PER_PAGE;
    const splideOptions = {
        perPage: PER_PAGE,
        rewind: true,
        pagination: false,
        arrows: isMultiPage,
        drag: isMultiPage && Skubacz.Device.isTouch(),
        breakpoints: {
            [(_a = Skubacz.Device.breakpoints.smallMin) !== null && _a !== void 0 ? _a : 640]: {
                perPage: 1,
            },
        },
        gap: "1rem",
    };
    return (h("fieldset", { class: "m-form__group m-form__group--spacing-top" },
        h(Splide
        // @ts-ignore - className works but is not in the types (https://splidejs.com/integration/react-splide/#props)
        , { 
            // @ts-ignore - className works but is not in the types (https://splidejs.com/integration/react-splide/#props)
            className: "m-crossup m-crossup--redesigned splide splide--rwd m-crossup--with-title", options: splideOptions, hasTrack: false, "aria-labelledby": uuid.current },
            h("div", { class: "row" },
                h("div", { class: "col-md-12" },
                    h("div", { class: "m-crossup__header" },
                        h("h4", { class: "m-crossup__title", id: uuid.current }, translate(t.crossup.title)),
                        h("div", { class: "m-crossup__nav splide__arrows" },
                            h("button", { type: "button", class: "m-crossup__arrow u-btn-unstyled splide__arrow splide__arrow--prev", "aria-label": translate(t.views.pagination.previous), role: "button" },
                                h("i", { class: "icon-btn icon-left", "aria-hidden": "true" })),
                            h("button", { type: "button", class: "m-crossup__arrow u-btn-unstyled splide__arrow splide__arrow--next", "aria-label": translate(t.views.pagination.next), role: "button" },
                                h("i", { class: "icon-btn icon-right", "aria-hidden": "true" })))))),
            h("div", { class: "row" },
                h("div", { class: "col-md-12" },
                    h("div", { class: "m-crossup__body splide__track" },
                        h("div", { class: "m-crossup__list splide__list" }, items.map((item) => (h(SplideSlide, { key: item.id },
                            h(CrossSellingItem, { item: item })))))))))));
}
export default observer(CrossSellingList);
